import { render, staticRenderFns } from "./installPromts.vue?vue&type=template&id=5e241c98&scoped=true"
import script from "./installPromts.vue?vue&type=script&lang=js"
export * from "./installPromts.vue?vue&type=script&lang=js"
import style0 from "./installPromts.vue?vue&type=style&index=0&id=5e241c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e241c98",
  null
  
)

export default component.exports